module.exports = __webpack_public_path__ + "img/375.298e6578.jpg";